<template>
    <div class="box">
        <inner-table id="archiveConInfo" ref="archiveConInfo" :listviewurl="'rsgl.archiveConInfo.list'" :can-edit="canEdit" :can-delete="canEdit" :link-prop-name="'archivesId'" />
    </div>
</template>

<script>
const moment = require('moment')
export default {
    components: {
    },
    props: {
        vo: { type: Object, default: function() { return {} } },
        canEdit: { type: Number, default: 1 }
    },
    data() {
        return {
        }
    },
    computed: {},
    watch: {},
    created: function() {
    },
    mounted: function() {
    },
    methods: {
        addObject6() {
            this.$bus.emit('openBusiform', this.moduleInfo, null, 1)
        },
        // 内嵌子表-加载数据后回调
        onInnerTableListDataLoaded($scope, pageInfo) {
            pageInfo.list.forEach(v => {
                v.conStartDate = v.conStartDate ? moment(v.conStartDate).format('YYYY-MM-DD') : ''
                v.conEndDate = v.conEndDate ? moment(v.conEndDate).format('YYYY-MM-DD') : ''
            })
        }
    }
}
</script>

<style scoped>
.header {
    padding:10px 20px;
    background-color: #f2f5fb;
    font-size: 14px;
    font-weight: 500;
}
.box {
   border:1px solid #dee2e6;
}
</style>

